/* eslint-disable complexity */
import { useEffect, useContext } from "react";

import { css } from "@compiled/react";
import { useInView } from "react-intersection-observer";

import UFOSegment from "@atlassian/wac-ufo-segment";

import { Adg4Button } from "@/components/adg4/button/src";

import { TeamType, ScrollContext } from "./scroll-pinned-sections";
export const HomepageSectionScrollItem = (props: TeamType) => {
    const { ref: scrollRef, inView: sectionIsVisible } = useInView({
        threshold: 0.1,
        rootMargin: "-40% 0px -40% 0px"
    });
    const {
        setActiveAccentImg,
        setActiveBrand,
        setActiveColor,
        setActiveCTA,
        setActiveCTALink,
        setActiveCTALabel,
        setActiveShape,
        setActiveFeatureVideo,
        setActivePosterImage,
        setActiveIndex
    } = useContext(ScrollContext);
    useEffect(() => {
        if (sectionIsVisible) {
            setActiveAccentImg(props.accentImg);
            setActiveBrand(props.brand);
            setActiveColor(props.bgColor);
            setActiveCTA(props.cta);
            setActiveCTALink(props.ctaLink);
            setActiveCTALabel(props.ctaLabel);
            setActiveIndex(props.index || 0);
            setActiveShape(props.bgShape);
            setActiveFeatureVideo(props.featureVideo);
            setActivePosterImage(props.posterImage);
        }
    });
    return (
        <UFOSegment name="homepage-section-scroll-item">
            <div className="team-type">
                <div
                    className={`team-card ${
                        sectionIsVisible ? "active" : "inactive"
                    }`}
                    ref={scrollRef}
                >
                    <div css={[logoStyles]}>
                        {props.logo}
                        <h4>{props.productName}</h4>
                    </div>
                    <h3 css={h3Styles}>{props.header}</h3>
                    <p css={descriptionStyles}>{props.description}</p>
                    <div css={quoteStyles}>
                        <p css={quotePStyles}>
                            &ldquo;
                            {props.quote}
                            &rdquo;
                        </p>
                        <img
                            css={portraitStyles}
                            src={props.portrait}
                            alt={props.name}
                        />
                        <img
                            css={brandStyles}
                            src={props.brand}
                            alt={props.title}
                        />
                        <p css={nameStyles}>{props.name}</p>
                        <p css={titleStyles}>{props.title}</p>
                    </div>
                </div>
                <div className="img-region">
                    <div
                        className="bg-shape"
                        style={{
                            clipPath: `polygon(${props.bgShape})`,
                            backgroundColor: `#${props.bgColor}`
                        }}
                    />
                    <img
                        src={props.accentImg}
                        className={`img-accent`}
                        alt={""}
                    />
                    <img
                        src={props.posterImage}
                        className="img-screenshot"
                        alt=""
                    />
                </div>
                {props.ctaLink && (
                    <Adg4Button
                        className="cta-button"
                        variant="primary"
                        color="blue"
                        href={props.ctaLink}
                        dataEventProps={{
                            "data-product-key": "home",
                            "data-event": "clicked",
                            "data-event-component": "linkButton",
                            "data-event-container": "ctaSection",
                            "data-label": props.cta,
                            "data-label-english": props.ctaLabel
                        }}
                    >
                        {props.cta}
                    </Adg4Button>
                )}
            </div>
        </UFOSegment>
    );
};
const logoStyles = css({
    display: "flex",
    margin: "0 0 10px 0",
    alignItems: "center",
    svg: {
        boxSizing: "border-box",
        background: "#1868DB",
        padding: "5px",
        width: "33px",
        height: "33px"
    },
    h4: {
        margin: "0 0 0 10px"
    }
});
const h3Styles = css({
    fontSize: "2rem",
    margin: 0
});
const descriptionStyles = css({
    fontSize: "1.25rem",
    margin: "0 30px 30px 0"
});
const quoteStyles = css({
    backgroundColor: "#f8f8f8",
    padding: "20px 20px 20px 80px",
    position: "relative"
});
const portraitStyles = css({
    position: "absolute",
    width: "68px",
    insetInlineStart: "0",
    insetBlockStart: "20px"
});
const brandStyles = css({
    position: "absolute",
    width: "30px",
    insetInlineStart: "40px",
    insetBlockStart: "60px"
});
const quotePStyles = css({
    position: "relative",
    fontSize: "0.875rem",
    margin: "0 0 1rem"
});
const nameStyles = css({
    position: "relative",
    fontWeight: 600,
    fontSize: "0.875rem",
    margin: 0
});
const titleStyles = css({
    position: "relative",
    margin: 0,
    textTransform: "uppercase",
    letterSpacing: "0.01rem",
    fontSize: "0.875rem"
});
